// extracted by mini-css-extract-plugin
module.exports = {"userHeading":"SiteHeading_userHeading__2qndV","userHeadingDescription":"SiteHeading_userHeadingDescription__1oDaE"};